import React from "react";
import { Button } from "reactstrap";
import NavHeader from "./NavHeader";
import NavRow from "./NavRow";
import AgregarEquipoModal from "./AgregarEquipoModal";
import { equiposActivos, nuevoEquipoDeTorneo } from "./equipos";
import { cleanString } from "components/utils/cleanString";

// Lista de equipos participantes del torneo, filtrable por nombre. El alta se hace
// desde un modal (AgregarEquipoModal); cada equipo abre su roster (TeamScreen) en
// drill-down. Los que están de baja (abandonaron) no se muestran: siguen en `teams`
// sólo para que las ruedas cerradas conserven sus nombres.
//
// La baja la resuelve el host (onRemoveTeam): además de confirmarla, tiene que sacar
// al equipo de las zonas, listas de fe y partidos de la última rueda, que desde acá
// no se ven.
export default function TeamsScreen({ teams, equipos, jugadores, onChange, onRemoveTeam, onOpenTeam, onBack }) {
  const [filtro, setFiltro] = React.useState("");
  const [modalAbierto, setModalAbierto] = React.useState(false);

  const activos = equiposActivos(teams);
  const filtrados = activos
    .map((team, index) => ({ team, index }))
    .filter(({ team }) => cleanString(team.name).includes(cleanString(filtro)));

  const addTeam = (option) => {
    if (!option || !option.label) return;

    // Sacar el equipo elegido de las opciones para que no se pueda repetir.
    const index = equipos.findIndex((e) => e.value === option.value);
    if (index >= 0) equipos.splice(index, 1);

    // Si estaba de baja vuelve a competir, con la lista de fe que tenía.
    if (teams.some((t) => t.id === option.value)) {
      onChange(teams.map((t) => (t.id === option.value ? { ...t, baja: false } : t)));
      return;
    }

    // El equipo se agrega con la lista de fe precargada.
    onChange([...teams, nuevoEquipoDeTorneo(option, jugadores)]);
  };

  return (
    <div className="screen-slide">
      <NavHeader title="Equipos" subtitle={activos.length + " cargados"} onBack={onBack} />

      <div className="card mb-3">
        <div className="card-body d-flex align-items-center">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por nombre..."
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
          <Button className="btn-arhock ml-2 my-0 text-nowrap" onClick={() => setModalAbierto(true)}>
            Agregar Equipo
          </Button>
        </div>
      </div>

      <AgregarEquipoModal
        isOpen={modalAbierto}
        teams={activos}
        equipos={equipos}
        onAccept={addTeam}
        onClose={() => setModalAbierto(false)}
      />

      {activos.length === 0 ? (
        <div className="empty-state">
          <svg className="empty-state-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
          <p className="mb-1 font-weight-bold">No hay equipos</p>
          <p className="text-muted" style={{ fontSize: "0.875rem" }}>
            Agregá el primer equipo para comenzar a construir tu torneo. Podrás cargar hasta 14 jugadores por equipo.
          </p>
        </div>
      ) : filtrados.length === 0 ? (
        <p className="text-muted text-center" style={{ fontSize: "0.875rem" }}>
          Ningún equipo coincide con "{filtro}".
        </p>
      ) : (
        filtrados.map(({ team, index }) => (
          <NavRow
            key={team.id}
            title={team.name || "Equipo " + (index + 1)}
            badges={[{ label: team.players.length + "/14 jugadores", variant: "arhock" }]}
            compact
            onClick={() => onOpenTeam(team.id)}
            onDelete={() => onRemoveTeam(team.id)}
          />
        ))
      )}
    </div>
  );
}
